module.exports = __webpack_public_path__ + "img/press_brake.b9916299.png";